import { render, staticRenderFns } from "./DuelCard.vue?vue&type=template&id=52bc1899&lang=pug"
import script from "./DuelCard.vue?vue&type=script&lang=js"
export * from "./DuelCard.vue?vue&type=script&lang=js"
import style0 from "./DuelCard.vue?vue&type=style&index=0&id=52bc1899&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports